module.exports = __webpack_public_path__ + "media/Video 140.8bc7d6ec.mp4";